import { Accordion, AccordionDetail, AccordionHeader, AccordionItem, AccordionTitle } from "@vds/accordions";
import { DropdownSelect } from "@vds/selects";
import { useStatisticContext } from "../../contexts/StatisticContext";
import { STATISTICS_TEST_IDS } from "../../statisticsConstants";

const ObjectTypeSelection = () => {
  const {
    activeObjectNameAccordion,
    setActiveObjectNameAccordion,
    eventAppObjectClassList,
    filterlist,
    objectNameToggleDropdown,
    selectedEventAppObject,
    setDateTimeToggleDropdown,
    setFilterList,
    setObjectNameToggleDropdown,
    setSelectedEventAppObject,
    showObjectTypeDropdown
  } = useStatisticContext();

  const toggleObjectTypeAccordion = (index, e) => {
    setObjectNameToggleDropdown(activeObjectNameAccordion === index ? false : true);
    setActiveObjectNameAccordion(activeObjectNameAccordion === index ? null : index);
  };

  if (!showObjectTypeDropdown || eventAppObjectClassList.length === 0) {
    return null;
  }

  const handleObjectTypeClick = (e) => {
    toggleObjectTypeAccordion(5, e);
    setObjectNameToggleDropdown(true);
  };

  const handleObjectTypeChange = (e) => {
    setSelectedEventAppObject(e.target.value);
  };

  return (
    <>
      <div className="filterTowerItemSeparator"></div>
      <div className="filterTowerItems">
        <div className="statisticsAccordion">
          <Accordion>
            <AccordionItem opened={activeObjectNameAccordion === 5} style={{ fontSize: "16px", width: "90%" }}>
              <AccordionHeader
                triggerType="icon"
                style={{
                  height: "20px",
                  width: "20px",
                  top: "8px"
                }}
                data-testid={STATISTICS_TEST_IDS.ACCORDION_HEADER_OBJECT_TYPE}
                onClick={(e) => handleObjectTypeClick(e)}
              >
                <AccordionTitle>
                  <div className="flexColumn">
                    <div className="flexRow">
                      <p
                        style={{
                          fontWeight: "100",
                          margin: "0"
                        }}
                        size="small"
                      >
                        Object type
                      </p>
                    </div>
                    {activeObjectNameAccordion !== 5 && (
                      <div className="filterSelectedVal">
                        Selected : <span> {selectedEventAppObject ? selectedEventAppObject : "All Objects"} </span>
                      </div>
                    )}
                  </div>
                </AccordionTitle>
              </AccordionHeader>
              <AccordionDetail>
                {objectNameToggleDropdown && (
                  <DropdownSelect
                    width="90%"
                    style={{
                      borderColor: "transparent",
                      borderStyle: "none"
                    }}
                    label="Objects"
                    errorText="Select a Object"
                    error={false}
                    disabled={false}
                    readOnly={false}
                    inlineLabel={false}
                    value={selectedEventAppObject}
                    onChange={(e) => handleObjectTypeChange(e)}
                  >
                    <option value="">All Objects</option>
                    {eventAppObjectClassList.map((object, i) => {
                      return (
                        <option label={object} value={object}>
                          {object}
                        </option>
                      );
                    })}
                  </DropdownSelect>
                )}
              </AccordionDetail>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </>
  );
};

export default ObjectTypeSelection;
